import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";

const subsection_style = {
  fontSize: "1.5em",
  fontWeight: "normal",
  marginBottom: "0.3em",
  marginTop: "0.8em",
};

export default subsection_style;
